<soft-page>
  <soft-page-header>
    <div class="flex items-center justify-between gap-2 w-full">
      <button
        type="button"
        class="flex flex-col text-start gap-0.5"
        (click)="openDatePicker()"
      >
        <span class="soft-overline">{{ date() | date:'EEEE' }}</span>
        <span class="font-bold hover:underline hover:cursor-pointer">
          {{ date() | date:'dd.MM.yyyy' }}
        </span>
        <span class="text-xs text-light">KW {{ date() | date:'ww' }}</span>
      </button>
      <soft-ds-prev-curr-next-navigation
        (previous)="navigatePrev()"
        (today)="navigateToday()"
        (next)="navigateNext()"
      />
    </div>
  </soft-page-header>
  <soft-time-report-list
    (selectedChange)="navigateToEditPage($event)"
  ></soft-time-report-list>
</soft-page>
